import React from 'react';
import { getTranslation } from '../utils/config';
import { useDfContext } from '../context/df-context';
import { LoadingRing } from './loading-ring';

export default function SearchResults(): React.ReactElement {
  const {
    state: { totalDownloads, isLoading },
  } = useDfContext();
  return (
    <span className="df-search-modul__results">
      {isLoading ? (
        <>
          <LoadingRing />
          <span>{getTranslation('results_counter')}</span>
        </>
      ) : (
        <p>
          <strong className="df-search-modul__total-results">{totalDownloads}</strong>
          {getTranslation(totalDownloads === 1 ? 'search_result_hit' : 'search_result_hits')}
        </p>
      )}
    </span>
  );
}
